import { render } from "./contactSegments.vue?vue&type=template&id=654e4e1c"
import script from "./contactSegments.vue?vue&type=script&lang=js"
export * from "./contactSegments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__